// extracted by mini-css-extract-plugin
export default {"svgHover":"Footer_svgHover__C9Phg"};